export default __webpack_public_path__ + "static/media/choc_oatmeal.c079b42f.jpg";